import { RepoType, camelToTitleCase } from '@quyva/common';
import { RepoStatKey } from './repoStatKeys';

export const getRepoStatLabel = (key, { storageType } = {}) => {
    if (key === RepoStatKey.TOTAL_PAGES && storageType === RepoType.INTERNET) {
        return 'Total Chunks';
    }
    if (key === RepoStatKey.PROCESSING_TIME) {
        return 'Total Processing Time';
    }
    if (key === RepoStatKey.LLM_MODEL) {
        return 'LLM Model';
    }
    if (key === RepoStatKey.SCHEMA_SIZE_KB) {
        return 'Schema Size (KB)';
    }
    return camelToTitleCase(key);
};
